









import { Component, Mixins, Prop } from 'vue-property-decorator';
import Mixin from '@/mixins/base';
import DeleteConfirmation from '@/layouts/DeleteConfirmation.vue';
import { Company } from '@/modules/backend/Entities/Company';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { resolveModule } from '@/store';

@Component({
  components: {
    DeleteConfirmation
  }
})
export default class CompanyDeleteDialog extends Mixins(Mixin) {
  @Prop({
    required: true,
    validator: (a: unknown): boolean => a instanceof Company
  })
  private readonly company!: Company;

  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);

  public async performDelete(): Promise<void> {
    await this.companiesModule.Remove(this.company);
  }
}
